import React, { useEffect, useState, useContext } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import api from '../../services/api';
import Swal from "sweetalert2";

export const ModalAprovacoesAprovar = ({
    loadTable,
    isOpen,
    setIsOpen,
    pendenciaDeAprovacao
}) => {
    var [descricao, setDescricao] = useState(null);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        }
    }

    const onAfterOpen = () => { };

    const closeModal = () => {
        setIsOpen(false);
    }

    const handleDescricao = (descricao) => {
        setDescricao(descricao.target.value);
    }

    const formActivities = async () => {
        Swal.fire({
            title: 'Aguarde...',
            html: 'Aprovando...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading()
            },
        });
        let payload = {
            idPendenciaAprovacao: pendenciaDeAprovacao.idPendenciaAprovacao,
            descricao: descricao,
            // Aprovado
            Status: 2,
            // Aprovar
            IdTipoAcao: 2
        }

        if(pendenciaDeAprovacao?.atividadesProbono > 0) {
            Swal.fire({
                text: `Este TS possui ${pendenciaDeAprovacao?.totalHorasProBono} horas Pro bono, seguir com a aprovação?`,
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await api.put(`Aprovacoes/status`, payload)
                        .then(async (response) => {
                            await loadTable()
                            setIsOpen(false);
                            registrationSuccess();
                        })
                        .catch((error) => {
                            registrationFailure(error?.response?.data?.notification?.messageReturn)
                        });
                }
            });
        }
        else {
            await api.put(`Aprovacoes/status`, payload)
            .then(async (response) => {
                await loadTable()
                setIsOpen(false);
                registrationSuccess();
            })
            .catch((error) => {
                registrationFailure(error?.response?.data?.notification?.messageReturn)
            });
        }
    };

    const registrationSuccess = () => {
        Swal.fire({
            title: "Sucesso",
            text: "Aprovado com sucesso",
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
        });
    }

    const registrationFailure = (text = "Ops, ocorreu um erro!. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    }

    useEffect(() => {
        setDescricao(null);
    }, [pendenciaDeAprovacao])

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={closeModal}
            contentLabel="Timesheet Atividades"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={closeModal}>X</p>
            </StyledForm>
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <p className="modal-title">Aprovar</p>
                    </Flex.Item>
                </Flex>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group">
                            <div>
                                <p className="modal-info">Sigla</p>
                                <p className="modal-info-data"> {pendenciaDeAprovacao?.sigla} </p>
                                <p className="modal-info">Segurado</p>
                                <p className="modal-info-data"> {pendenciaDeAprovacao?.segurado?.seguradoNome} </p>
                                <p className="modal-info">Aprovador/Reprovador</p>
                                <p className="modal-info-data"> {pendenciaDeAprovacao?.nomeAprovador} </p>
                                {
                                    pendenciaDeAprovacao?.totalHorasProBono != '0,00' && (
                                        <>
                                            <p className="modal-info">Horas Pro Bono</p>
                                            <p className="modal-info-data"> {pendenciaDeAprovacao?.totalHorasProBono} </p>
                                        </>
                                    )
                                }
                            </div>
                        </div>
                    </Flex.Item>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group">
                            <div>
                                <p className="modal-info">Empresa </p>
                                <p className="modal-info-data">{pendenciaDeAprovacao?.nomeEmpresa} </p>
                                <p className="modal-info">Cliente</p>
                                <p className="modal-info-data"> {pendenciaDeAprovacao?.cliente?.clienteNome} </p>
                                <p className="modal-info">Disciplina</p>
                                <p className="modal-info-data"> {pendenciaDeAprovacao?.disciplina} </p>
                                {
                                    pendenciaDeAprovacao?.totalValorProBono != 'R$ 0,00' && (
                                        <>
                                            <p className="modal-info">Valor Pro Bono</p>
                                            <p className="modal-info-data"> {pendenciaDeAprovacao?.totalValorProBono} </p>
                                        </>
                                    )
                                }
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <div style={{ width: '100%' }} className="position-relative form-group">
                        <textarea rows="3" className="input-form" placeholder='Descrição' name='descricao' onBlur={handleDescricao} />
                    </div>
                </Flex>

                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group modal-align-center">
                            <input className='default-button-red' value='Aprovar' type="button" onClick={formActivities} />
                        </div>
                    </Flex.Item>
                </Flex>
            </StyledForm>
        </Modal>);
};
